<template>
  <section v-if="data">
    <NuxtPage :page-key="route => route.fullPath" />
    <PagesProjectsComponent :data="data" />
  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
useHead({
  htmlAttrs: { 'data-page-type': 'projects' }
})

// 2
const i18nActiveIso = baseI18nGetActiveIso()

const { data, error } = await useAsyncData(() =>
  fetchQueryPath( queryProjectsPage( i18nActiveIso ) )
)

basePageSetHead(data)
</script>
